import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'mi',
    fullName: 'Māori',
    nativeName: 'Māori',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "He mea whakamiharo kei te haere mai",
    landing_subtitle: "Ko ArgVoid he taupānga me te studio whanaketanga keemu. Kia mau tonu, kei te tata mai nga mea hou!",
    select_language: "Tīpakohia te Reo",
    search_placeholder: "Rapu reo...",
    terms_title: "Nga Ture Ratonga",
    policy_title: "Kaupapahere Tūmataiti",
    cookies_title: "Kaupapahere Pihikete",
    terms_content: `
        <strong>1. Whakaaetanga o Nga Ture</strong><br>
        Ma te uru atu ki ArgVoid, ka whakaaetia enei Ture Ratonga. Ki te kore e whakaaehia enei tikanga, kaua e whakamahia te ratonga.<br><br>

        <strong>2. Whakamahinga Papa </strong><br>
        Ko ArgVoid me ana tono ka tukuna "penei" mo nga kaupapa korero me nga kaupapa auaha. Me whakamahi te ratonga mo nga kaupapa tika.<br><br>

        <strong>3. Nga Mahi Rahui</strong><br>
        Ko te whakamahi i nga whakaraeraetanga o te waahi, te mokomoko, te ngana ranei ki te uru kore mana ki te hanganga ka tino aukatia.<br><br>

        <strong>4. Whakakahoretanga</strong><br>
        Ka taea te whakarereke i te turanga me nga ratonga i nga wa katoa kaore he panui. Karekau he raihana e whakaratohia ana mo te wa e waatea ana te ratonga.
    `,
    policy_content: `
        <strong>1. Kohinga korero</strong><br>
        Kaore e hiahiatia e te papaaho te motuhēhēnga kaiwhakamahi, te hanga pūkete ranei i tenei wa. Karekau he korero tautuhi whaiaro (penei i nga ingoa, i nga wahitau imeera ranei) ka kohia mai i nga manuhiri.<br><br>

        <strong>2. Raraunga Raraunga</strong><br>
        Ka kohia pea nga tātaritanga taketake, ingoamuna ki te mohio ki te hokohoko o te waahi me te whakapai ake i nga tono. Ko enei raraunga kaore i te hono ki nga tuakiri kaiwhakamahi takitahi.<br><br>

        <strong>3. Ratonga Tuatoru</strong><br>
        Ka whakamahia pea nga kaiwhakarato tuatoru mo nga ratonga manaaki me te tātari. Ko nga mahi tūmataitinga o enei kaiwhakarato e whakahaere ana i nga raraunga ingoamuna i tukatukahia i runga i o raatau hanganga.<br><br>

        <strong>4. Haumarutanga Raraunga</strong><br>
        Ka whakatinanahia nga tikanga haumaru tika hei tiaki i te papa. Heoi, karekau he tikanga tuku i runga i te Ipurangi e tino haumaru.<br><br>
    `,
    cookies_content: `
        <strong>1. He aha nga Pihikete me te Rokiroki Rohe?</strong><br>
        Ko nga pihikete me te rokiroki paetata he konae raraunga iti kei te rongoa i runga i te taputapu hei maumahara i nga manakohanga whirihoranga puta noa i nga haerenga.<br><br>

        <strong>2. Kaupapa Whakamahi</strong><br>
        Ka whakamahia te Pūtirotiro LocalStorage ki te tiaki i nga tautuhinga whirihoranga, penei:<br>
        - Nga manakohanga reo<br>
        - Te whirihoranga atanga kaiwhakamahi (hei tauira, te whakatakotoranga, te whakatakotoranga kaupapa ranei)<br>
        - Keteroki tono rangitahi<br><br>

        <strong>3. Kore Aroturuki</strong><br>
        Kaore nga pihikete me te rokiroki o te rohe e whakamahia ana mo te panui, mo nga kaupapa aroturuki tuatoru ranei. Ko nga raraunga rongoa katoa mo te mahinga matua o te turanga.<br><br>

        <strong>4. Mana</strong><br>
        Ka taea te whakakore i nga raraunga tirotiro i nga wa katoa na roto i nga tautuhinga tirotiro, ka tautuhi ano i nga whirihoranga rohe.
    `,
    cookie_consent_text: "Ka whakamahi matou i nga pihikete taketake hei whakarite kia tika te mahi a te paetukutuku, penei i te noho kaha o to huihuinga, te tiaki i to hiahia reo, me etahi atu whirihoranga ritenga.",
    read_policy: "Panui Kaupapahere Pihikete",
    support_title: "Whakapā Tautoko",
    support_subject_label: "Kaupapa",
    support_message_label: "Karere",
    support_submit_button: "Tuku Karere",
    support_hint: "Tuhipoka: Ma tenei ka whakatuwhera i to tono imeera taunoa hei tuku i te karere.",
    support_success_msg: "Kei te whakatuwhera i to taupānga imeera...",
    support_error_msg: "I rahua te tuku karere. Me ngana ano i muri mai.",
    explorer_title: "Kaitirotiro",
    history_title: "Hītori",
    animation_title: "Hākoritanga",
    config_title: "Whirihoranga",
    tool_mouse: "Tīpakohia (Ctrl+M)",
    tool_brush: "Paraihe (Ctrl+B)",
    tool_brush_mode: "Aratau Takahuri (Maro/Maama)",
    tool_eraser: "Kaimuku (Ctrl+E)",
    tool_brush_size: "Whakaritea te Rahi Paraihe",
    tool_bucket: "Whakakī (Ctrl+F)",
    tool_eyedropper: "Kaipatu kanohi",
    tool_grid: "Mātiti (Ctrl+Shift+B)",
    tool_rotate: "Tītaka (Ctrl+Shift+R)",
    tool_flip_h: "Pore ​​H (Ctrl+Shift+H)",
    tool_flip_v: "Pore ​​V (Ctrl+Shift+V)",
    tool_transpose: "Whakawhiti (Ctrl+Shift+T)",
    label_width: "Whānui",
    label_height: "Teitei",
    label_frames: "Te maha o nga Papa",
    label_animation: "Kāhua Hākoritanga",
    label_background_color: "Tae Papamuri",
    label_interval: "Wātanga",
    tool_anim_config: "Whirihoranga Animation",
    label_new_width: "Whanui Hou",
    label_new_height: "Teitei Hou",
    label_apply: "Tonoa",
    label_colors: "Nga Tae",
    label_size: "Rahi",
    label_tolerance: "Te manawanui",
    val_horizontal: "Whakapae",
    val_vertical: "Poutū",
    val_sequence: "Raupapa",
    val_bounce: "Panuku",
    val_random: "Matapōkeretia",
    val_solid: "Mārō",
    val_clear: "Maamaa",
    action_add_sheet: "Pepa Hou",
    action_import: "Kawemai",
    action_export: "Kaweake",
    action_sort_projects: "Kōmaka",
    sort_date_old: "Tawhito Tuatahi",
    sort_date_new: "Hou Tuatahi",
    sort_name_az: "Ingoa (A-Z)",
    sort_name_za: "Ingoa (Z-A)",
    action_new_sprite: "Sprite Hou",
    action_new_project: "Kaupapa Hou",
    modal_save_all_title: "Tiakina nga Huringa Katoa",
    modal_save_all_desc: "Tīpakohia ngā rawa hei tiaki:",
    modal_save_selected: "Tiaki kua tohua",
    action_saved: "Whakaorangia",
    modal_create_sprite_title: "Waihanga Sprite Hou",
    modal_create_project_title: "Waihanga Kaupapa Hou",
    modal_add_sheet_title: "Tāpiri Rau Hou",
    modal_rename_sheet_title: "Whakaingoa Hou Pepa",
    modal_rename_sprite_title: "Whakaingoa ano ko Sprite",
    modal_delete_sprite_title: "Mukua Sprite",
    modal_delete_project_title: "Muku Kaupapa",
    modal_delete_sheet_title: "Muku Rau",
    placeholder_sprite_name: "Ingoa",
    placeholder_project_name: "Ingoa",
    placeholder_sheet_name: "Ingoa",
    placeholder_new_name: "Ingoa Hou",
    action_create: "Waihanga",
    action_add: "Tāpiri",
    action_rename: "Whakaingoa ano",
    action_duplicate: "Tārite",
    action_delete: "Mukua",
    action_cancel: "Whakakore",
    confirm_delete_sprite: "Kei te tino hiahia koe ki te muku i tenei sprite?",
    confirm_delete_project: "E tino hiahia ana koe ki te muku i tenei kaupapa? Ka tangohia nga sprites katoa.",
    confirm_delete_sheet: "Me muku tenei rau?",
    err_select_sprite: "Tīpakohia he sprite i te tuatahi.",
    err_select_project: "Tīpakohia he kaupapa i te tuatahi.",
    err_name_empty: "Ko te ingoa kaore e taea te putua.",
    err_sprite_exists: "Kei te noho kē he sprite me taua ingoa.",
    err_project_exists: "He kaupapa me taua ingoa kua noho.",
    err_no_content: "Karekau he ihirangi hei tiaki.",
    err_no_changes: "Kaore he huringa hei tiaki.",
    err_delete_last_sheet: "Kāore e taea te muku te rau whakamutunga.",
    err_extract_frames: "Kāore i taea te unu i ngā tāpare.",
    err_indexeddb: "I rahua te tiaki i te rohe. Kaore pea to kaitirotiro e tautoko i te IndexedDB.",
    msg_upload_success: "I Angitu te Tukuake: {0}",
    msg_upload_failed: "I Rahua te Tukuake: {0}",
    msg_save_success: "Tiaki angitu.",
    msg_saving: "Tiaki...",
    msg_multi_save_result: "{0} rawa kua tiakina. {1} rahunga.",
    menu_title: "Tahua",
    menu_save: "Tiaki",
    menu_save_all: "Tiaki Katoa",
    menu_support: "Whakapā Tautoko",
    label_local_storage: "Rokiroki rohe",
    label_sign_in: "Waitohu Mai",
    modal_export_title: "Kaweake Sprite",
    label_filename: "Ingoa Kōnae",
    label_format: "Whakahōputu",
    action_export_confirm: "Kaweake",
};

export default translations;
